import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-remove-file-dialog',
	templateUrl: './remove-file-dialog.component.html',
	styleUrls: ['./remove-file-dialog.component.scss']
})
export class RemoveFileDialogComponent implements OnInit {

	fileName: string;
	description: string;
	translateContext = TranslateContext;

	constructor(public dialogRef: MatDialogRef<RemoveFileDialogComponent>,) {
	}

	ngOnInit() {
	}

	onClick(event: any) {
		this.dialogRef.close(true);
	}

}
